// localStorage.clear() is the right behaviour on logout and on a 401 — except for one
// key. The login page is unauthenticated, so the only way it can show a dairy-targeted
// advert is to remember which dairy this device last logged into. That hint is not
// credentials and is useless to an attacker; losing it just means a global ad.
export const LAST_DAIRY_KEY = "last_dairy_id";

export const clearSessionKeepingAdHint = () => {
  const hint = localStorage.getItem(LAST_DAIRY_KEY);
  localStorage.clear();
  if (hint) localStorage.setItem(LAST_DAIRY_KEY, hint);
};
